export const STORE_KEY = '@@meta'
export const GET_SHOPPING_CART_META_REQUEST = `${STORE_KEY}/GET_SHOPPING_CART_META_REQUEST`
export const GET_SHOPPING_CART_META_SUCCESS = `${STORE_KEY}/GET_SHOPPING_CART_META_SUCCESS`
export const GET_SHOPPING_CART_META_FAILURE = `${STORE_KEY}/GET_SHOPPING_CART_META_FAILURE`
export const GET_TRACKERS_REQUEST = `${STORE_KEY}/GET_TRACKERS_REQUEST`
export const GET_TRACKERS_SUCCESS = `${STORE_KEY}/GET_TRACKERS_SUCCESS`
export const GET_TRACKERS_FAILURE = `${STORE_KEY}/GET_TRACKERS_FAILURE`
export const GET_SCRIPTS_REQUEST = `${STORE_KEY}/GET_SCRIPTS_REQUEST`
export const GET_SCRIPTS_SUCCESS = `${STORE_KEY}/GET_SCRIPTS_SUCCESS`
export const GET_SCRIPTS_FAILURE = `${STORE_KEY}/GET_SCRIPTS_FAILURE`
export const GET_TERMS_AND_CONDITIONS_REQUEST = `${STORE_KEY}/GET_TERMS_AND_CONDITIONS_REQUEST`
export const GET_TERMS_AND_CONDITIONS_SUCCESS = `${STORE_KEY}/GET_TERMS_AND_CONDITIONS_SUCCESS`
export const GET_TERMS_AND_CONDITIONS_FAILURE = `${STORE_KEY}/GET_TERMS_AND_CONDITIONS_FAILURE`
export const SET_BOT_META = `${STORE_KEY}/SET_BOT_META`
export const GET_ADDRESS_FORMAT_REQUEST = `${STORE_KEY}/GET_ADDRESS_FORMAT_REQUEST`
export const GET_ADDRESS_FORMAT_SUCCESS = `${STORE_KEY}/GET_ADDRESS_FORMAT_SUCCESS`
export const GET_ADDRESS_FORMAT_FAILURE = `${STORE_KEY}/GET_ADDRESS_FORMAT_FAILURE`
export const GET_MENU_FEATURES_REQUEST = `${STORE_KEY}/GET_MENU_FEATURES_REQUEST`
export const GET_MENU_FEATURES_SUCCESS = `${STORE_KEY}/GET_MENU_FEATURES_SUCCESS`
export const GET_MENU_FEATURES_FAILURE = `${STORE_KEY}/GET_MENU_FEATURES_FAILURE`
export const GET_STRIPE_TOKEN_REQUEST = `${STORE_KEY}/GET_STRIPE_TOKEN_REQUEST`
export const GET_STRIPE_TOKEN_SUCCESS = `${STORE_KEY}/GET_STRIPE_TOKEN_SUCCESS`
export const GET_STRIPE_TOKEN_FAILURE = `${STORE_KEY}/GET_STRIPE_TOKEN_FAILURE`
